import { PiniaColada } from "@pinia/colada";
// oxlint-disable-next-line no-restricted-imports -- platform islands still register the tanstack plugin
import { VueQueryPlugin } from "@tanstack/vue-query";
import { createPinia } from "pinia";
import { createApp } from "vue";

import type { VueIslandConfig } from "@solvari/common-fe/helpers";

import { initVueIslands } from "@solvari/common-fe/helpers";
import { useQueryClient } from "@solvari/common-fe/integrations";
import {
  HeaderContact,
  initPrimeVue,
  SFooterBottom,
  SFooterMain,
  SGeoProductCategories,
  SHeaderBase,
  SHeaderMain,
  SHeaderPro,
  SLocalSearchProvinces,
} from "@solvari/components";

function initPlatformVueIslands() {
  const components: VueIslandConfig = {
    headerContact: () => Promise.resolve(HeaderContact),
    headerBase: () => Promise.resolve(SHeaderBase),
    headerMain: () => Promise.resolve(SHeaderMain),
    headerPro: () => Promise.resolve(SHeaderPro),
    footer: () => Promise.resolve(SFooterMain),
    footerBottom: () => Promise.resolve(SFooterBottom),
    chatBlock: () => import("@/shared/components/chat/ChatBlock.vue"),
    brochureForm: () =>
      import("@/platform/components/brochure-form/BrochureForm.vue"),
    productSearch: () =>
      import("@/platform/components/homepage/product-search/productSearch.ts"),
    explanationAnimation: () =>
      import("@solvari/components/blade/explanation-animation/ExplanationAnimation.vue"),
    sBlogList: () => import("@/platform/components/blog/SBlogList.vue"),
    sProSuccessBlogList: () =>
      import("@/platform/components/blog/SProSuccessBlogList.vue"),
    sProKnowledgeBlogList: () =>
      import("@/platform/components/blog/SProKnowledgeBlogList.vue"),
    sAffiliateForm: () =>
      import("@/affiliates/components/registration-form/SAffiliateForm.vue"),
    proProductSelect: () =>
      import("@/platform/components/intro/ProProductSelect.vue"),
    leadForm: () => import("@/platform/components/leadForm.ts"),
    sGeoProductCategories: () => Promise.resolve(SGeoProductCategories),
    sLocalSearchProvinces: () => Promise.resolve(SLocalSearchProvinces),
  };

  const pages: VueIslandConfig = {
    searchPage: () => import("@/platform/pages/search/SearchPage.vue"),
    reviewFormPage: () => import("@/platform/pages/ReviewFormPage.vue"),
  };

  const app = createApp({});
  const pinia = createPinia();
  app.use(pinia);
  app.use(PiniaColada, {});

  initVueIslands({ ...components, ...pages }, (app) => {
    app.use(pinia);
    app.use(PiniaColada, {});
    initPrimeVue(app);
    app.use(VueQueryPlugin, {
      enableDevtoolsV6Plugin: true,
      queryClient: useQueryClient(),
    });
  });
}

export { initPlatformVueIslands };
